import React, { Component } from 'react';
import './footer.css'
import { Col, Row, Button, InputGroup, InputGroupAddon, Input, Container } from 'reactstrap'
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { changeLang } from '../../../Redux/Action/LoginAction'
import String from '../../../Assets/locals'
import { API_ENDPOINT } from '../../../AppConfig'
import axios from 'axios'
import { showLoading, hideLoading } from 'react-redux-loading-bar'

class Footer extends Component {
  lang = () => {
    if (this.props.lang === "ar") {
      this.props.changeLang("en")
    } else {
      this.props.changeLang("ar")
    }
  }

  state = {
    departments: []
  }

  Fetch_Departments(lang) {
    this.props.showLoading();
    let uri = `${API_ENDPOINT}/departments`
    let token = `Bearer ${this.props.token}`
    axios.get(uri, {
      headers: {
        Authorization: token,
        "Accept-Language": lang,
        "Content-Type": 'application/json'
      }
    })
      .then(response => {
        this.setState({
          departments: response.data.data,
        })
        this.props.hideLoading();
      })
  }

  UNSAFE_componentWillMount() {
    let currentlang = this.props.lang
    this.setState({ currentlang: currentlang })
    this.Fetch_Departments(this.props.lang)
  }

  render() {
    String.setLanguage(this.props.lang);
    let first_col = []
    if (this.props.screenType === 'MAGAZINE') {
      first_col = [{ path: "/Magazin", title: String.home }, { path: "/Aboutus", title: String.about }, { path: "/volumes/fullvolumes", type: 'FULL', title: String.completeIssues }, { path: "/volumes/specialvolumes", type: 'PRIVATE', title: String.privateIssues },
      { path: "/Members", title: String.editorialBoard }, { path: "/Magazin", title: String.forms }]
    } else {
      first_col = [{ path: "/Promotion", title: String.home }, { path: "/Aboutus", title: String.about }, { path: "/Members", title: String.editorialBoard }, { path: "/Promotion", title: String.forms }]

    }
    let second_col = [{ path: this.props.screenType === 'MAGAZINE' ? "/Magazin" : '/Promotion', title: String.publicationRule }, { path: "/AllNews", title: String.news }, { path: this.props.screenType === 'MAGAZINE' ? "/Magazin" : '/Promotion', title: String.mailing }
    ]
    if (this.state.currentlang !== this.props.lang) {
      this.setState({ currentlang: this.props.lang }, () => this.Fetch_Departments(this.state.currentlang))
    }
    return (
      <footer style={{ direction: this.props.lang === "ar" ? "rtl" : "ltr", width: "100%" }}>
        <Container fluid>
          <Row style={{ textAlign: this.props.lang === "ar" ? "right" : "left" }}>
            <Col lg="3" className="pt-2">
              <ul>
                {first_col.map((element, index) => {
                  return (
                    <li key={index}><Link to={{ pathname: element.path, state: { volumeType: element.type } }}>{element.title}</Link></li>
                  )
                })}
              </ul>
            </Col>
            <Col lg="3" className="pt-2">
              <ul>
                {second_col.map((element, index) => {
                  return (
                    <li key={index}><Link to={{ pathname: element.path }}>{element.title}</Link></li>
                  )
                })}
              </ul>
            </Col>
            <Col lg="3" className="pt-3 pb-2 deptBTNS">
              <h5 className="mb-3">{String.Departments}</h5>
              {this.state.departments.map((dep, index) => {
                return (
                  <Button key={index} className={this.props.lang === "ar" ? "ml-2" : "mr-2"}>{dep.name}</Button>
                )
              })}
            </Col>
            <Col lg="3" className="callUs">
              <Row>
                <Col lg="12"><h4>{String.contactUs}</h4></Col>
                <Col lg="12" className="icons my-2">
                  <i style={{ margin: this.props.lang === "ar" ? "0 0 0 10px" : "0 10px 0 0" }} className="fa fa-twitter"></i>
                  <i className="fa fa-youtube"></i>
                  <i className="fa fa-google-plus"></i>
                  <i className="fa fa-facebook"></i>
                </Col>
                <Col lg="12" className="mt-2 mb-1"><p>{String.emailHint}</p></Col>
                <Col lg="10" className="mb-3">
                  <InputGroup>
                    <Input placeholder={String.email} />
                    <InputGroupAddon addonType="prepend"><span className="fa fa-envelope input-group-text"></span></InputGroupAddon>
                  </InputGroup>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col className="px-0">
              <div className="copyRight">
                <p className="pb-0 mb-0">{String.Rights}</p>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    )
  }
}
const mapStateToProps = state => {
  return {
    lang: state.login.language,
    screenType: state.login.screentype
  }
}
const mapDispatchToProps = dispatch => bindActionCreators(
  {
    changeLang,
    showLoading,
    hideLoading
  }
  , dispatch
)
export default connect(mapStateToProps, mapDispatchToProps)(Footer);